"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// import './App';
const Game_1 = __importDefault(require("./Game"));
const Menu_1 = __importDefault(require("./Menu"));
const game = new Game_1.default();
const menu = new Menu_1.default(game);
